module.exports = "/_next/static/images/f2447b4d7a2359ce7ba8850167e64420-app-screenshots-xs@3x.jpg.webp";